import React, { useCallback, useEffect, useState } from 'react';
import LoadingSkeleton from '../../components/ui/LoadingSkeleton';
import '../../styles/SecurityVisitorsPage.css';
import { listVisitors } from '../../services/guardService';

export default function SecurityVisitorsPage() {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  const fetchVisitors = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const res = await listVisitors({ page, search });
      if (res.success) {
        setVisitors(res.data || []);
        setPagination(res.pagination);
      }
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erreur lors du chargement des visiteurs');
    } finally {
      setLoading(false);
    }
  }, [page, search]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchVisitors();
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [fetchVisitors]);

  return (
    <div className="security-visitors-page">
      <div className="security-visitors-header">
        <div>
          <h1>Liste des visiteurs</h1>
          <p>Recherche rapide pour le poste de sécurité.</p>
        </div>
        <input
          type="text"
          className="search-input"
          placeholder="Rechercher par nom, email ou téléphone..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </div>

        {error && <div className="error-banner">{error}</div>}

        {loading ? (
          <LoadingSkeleton lines={8} />
        ) : (
          <div className="security-visitors-table-wrap">
            <table className="data-table security-visitors-table">
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Téléphone</th>
                  <th>VIP</th>
                  <th>Visites</th>
                  <th>Dernière visite</th>
                  <th>Prochaine venue</th>
                </tr>
              </thead>
              <tbody>
                {visitors.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="no-data">Aucun visiteur trouvé</td>
                  </tr>
                ) : visitors.map((visitor) => (
                  <tr key={visitor.id}>
                    <td>
                      {visitor.full_name}
                      {visitor.is_vip && <span className="vip-badge">★ VIP</span>}
                    </td>
                    <td>{visitor.email}</td>
                    <td>{visitor.phone}</td>
                    <td>{visitor.is_vip ? 'Oui' : 'Non'}</td>
                    <td>{visitor.visit_count || 0}</td>
                    <td>{visitor.last_visit ? new Date(visitor.last_visit).toLocaleDateString('fr-FR') : '—'}</td>
                    <td>{visitor.next_expected_at ? new Date(visitor.next_expected_at).toLocaleString('fr-FR') : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {pagination && pagination.totalPages > 1 && (
          <div className="pagination">
            <button disabled={page <= 1} onClick={() => setPage(page - 1)}>← Précédent</button>
            <span>Page {page} / {pagination.totalPages}</span>
            <button disabled={page >= pagination.totalPages} onClick={() => setPage(page + 1)}>Suivant →</button>
          </div>
        )}
      </div>
  );
}